import React, { useEffect } from "react";
import { useTheme } from "@emotion/react";
import "chart.js/auto";
import { Doughnut, Line } from "react-chartjs-2";
import {
  Analytics,
  FileCopy,
  MailOutline,
  Person,
  ShoppingBasket,
  Store,
  TrendingDown,
  TrendingUp,
} from "@mui/icons-material";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import SideBar from "../components/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { listOrders } from "../actions/ordrActions";
import { listProducts } from "../actions/productActions";
import { listBrand } from "../actions/brandActions";
import { listStores } from "../actions/storeActions";
import ChartComponent from "../components/ChartaComponent";

const DashBoardScreen = () => {
  const dispatch = useDispatch();
  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const orderList = useSelector((state) => state.orderList);
  const { loading, orders } = orderList;

  const productList = useSelector((state) => state.productList);
  const { products, loading: productLoading } = productList;

  const brandList = useSelector((state) => state.brandList);
  const { brands, loading: brandLoading } = brandList;

  const storeList = useSelector((state) => state.storeList);
  const { stores, loading: storeLoading } = storeList;

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    } else {
      dispatch(listOrders());
      dispatch(listProducts());
      dispatch(listBrand());
      dispatch(listStores());
    }
  }, [userInfo, navigate, dispatch]);

  return (
    <>
      {userInfo && (
        <Container>
          {loading ||
            productLoading ||
            brandLoading ||
            (storeLoading && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ))}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              pt: 10,
              backgroundColor: palette.background.default,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Card>
                  <CardContent className="card-items">
                    <Typography
                      className="ripple-icon"
                      variant="h5"
                      component="div"
                    >
                      <Analytics
                        style={{
                          color: palette.primary.main,
                        }}
                      />
                    </Typography>
                    <Typography
                      variant="h5"
                      style={{ justifyContent: "center", alignItems: "center" }}
                      component="div"
                    >
                      <Typography variant="h5" component={"h2"}>
                        {products && products.length}
                      </Typography>
                      <Typography variant="subtitle1" component={"h2"}>
                        Total products
                      </Typography>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={3}>
                <Card>
                  <CardContent className="card-items orange">
                    <Typography
                      className="ripple-icon"
                      variant="h5"
                      component="div"
                    >
                      <FileCopy
                        style={{
                          color: palette.warning.main,
                        }}
                      />
                    </Typography>

                    <Typography variant="h5" component={"h2"}>
                      {brands && brands.length}
                    </Typography>
                    <Typography variant="subtitle1" component={"h2"}>
                      Total brands
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={3}>
                <Card>
                  <CardContent className="card-items">
                    <Typography
                      className="ripple-icon"
                      variant="h5"
                      component="div"
                    >
                      <ShoppingBasket
                        style={{
                          color: palette.primary.main,
                        }}
                      />
                    </Typography>
                    <Typography variant="h5" component={"h2"}>
                      {orders && orders.length}
                    </Typography>
                    <Typography variant="subtitle1" component={"h2"}>
                      Total orders
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={3}>
                <Card>
                  <CardContent className="card-items">
                    <Typography
                      className="ripple-icon"
                      variant="h5"
                      component="div"
                    >
                      <Store
                        style={{
                          color: palette.success.main,
                        }}
                      />
                    </Typography>
                    <Typography>
                      <Typography variant="h5" component={"h2"}>
                        {stores && stores.length}
                      </Typography>
                      <Typography variant="subtitle1" component={"h2"}>
                        Total stores
                      </Typography>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <ChartComponent data={orders} title="total Sales" grid />
               
              </Grid>
              <Grid item xs={12} md={6}>
                <Doughnut
                  data={{
                    labels: ["Orders", "Products", "Brands", "Stores"],
                    datasets: [
                      {
                        label: "Sales",
                        backgroundColor: [
                          palette.primary.main,
                          palette.warning.main,
                          palette.success.main,
                          palette.error.main,
                        ],
                        data: [
                          orders && orders.length,
                          products && products.length,
                          brands && brands.length,

                          stores && stores.length,
                        ],
                      },
                    ],
                  }}
                  options={{
                    legend: {
                      display: true,
                      position: "bottom",

                      labels: {
                        fontColor: palette.text.secondary,
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      )}
    </>
  );
};

export default DashBoardScreen;
